/* eslint-disable @typescript-eslint/naming-convention */

export class ReservedWords {
	public static readonly UNDERSCORE = '_';
	public static readonly RXDBID = 'rxdbid';
	public static readonly RXDBIDSTRING = 'rxdbidstring';
	public static readonly ISDELETED = 'isDeleted';
	public static readonly DELETED = 'deleted';
	public static readonly REVISION = 'revision';
	public static readonly COLLECTION = 'collection';
	public static readonly PRIMARY = 'primary';

	public static readonly reservedWordsMap: { [key: string]: string } = {
		[ReservedWords.UNDERSCORE]: 'QL_UNDERSCORE_REPLACEMENT',
		[ReservedWords.RXDBID]: 'QL_RXDBID_REPLACEMENT',
		[ReservedWords.RXDBIDSTRING]: 'QL_RXDBIDSTRING_REPLACEMENT',
		[ReservedWords.ISDELETED]: 'QL_ISDELETED_REPLACEMENT',
		[ReservedWords.DELETED]: 'QL_DELETED_REPLACEMENT',
		[ReservedWords.REVISION]: 'QL_REVISION_REPLACEMENT',
		[ReservedWords.COLLECTION]: 'QL_COLLECTION_REPLACEMENT',
		[ReservedWords.PRIMARY]: 'QL_PRIMARY_REPLACEMENT'
	};
}
